import { createContext } from 'react';

// Create a context to manage the global dropdown state
// @ts-ignore
export const DropdownContext = createContext();
